import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import { DrawingBomContext } from "../../DrawingBomContext";
import { modalStyle } from "../../../../../../../../../components/modalStyle";
import { lightTable } from "../../../../../../../../../styles/muiProps";
import {
  createRow,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { changeOrderColumns } from "./columns";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { AuthContext } from "../../../../../../../../../context/authContext";

export default function ChangeOrderModalModal() {
  const { user } = useContext(AuthContext);
  const {
    openChangeOrderModal,
    handleCloseChangeOrderModal,
    consolidatedMaterials,
  } = React.useContext(DrawingBomContext);

  // console.log("consolidated Materials", consolidatedMaterials);
  const initialData =
    //   changeOrderColumns.reduce(
    //     (acc, col) => {
    //       if (col.accessorKey) acc[col.accessorKey] = "";
    //       return acc;
    //     },
    { bom: consolidatedMaterials };

  const [changeOrders, setChangeOrders] = useState([]);
  const [tableData, setTableData] = useState(initialData);

  const onChangeEstData = (e) => {};

  console.log("tableDta", tableData);
  const table = useMaterialReactTable({
    // data: coData({ changeOrders }),
    data: tableData,
    columns: changeOrderColumns({ user, tableData, setTableData }),

    ...lightTable,
    enableEditing: true,
    editDisplayMode: "row",
    createDisplayMode: "row",
    enableRowSelection: false,

    // ✅ GLOBAL DEFAULT FOR ALL EDIT CELLS
    muiEditTextFieldProps: {
      variant: "standard",
      size: "small",
      fullWidth: true,
    },

    // 👉 Save new row
    onCreatingRowSave: ({ values, table }) => {
      setChangeOrders((prev) => [...prev, values]);
      table.setCreatingRow(null); // exit create mode
    },

    // 👉 Cancel create
    onCreatingRowCancel: () => {
      console.log("Create cancelled");
    },

    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "400px" } },
  });

  //   );
  const handleAddRow = () => {
    // 2. Wrap your initialData object with createRow
    const newRow = createRow(table, initialData);
    table.setCreatingRow(newRow);
  };

  return (
    <div>
      <Modal open={openChangeOrderModal} onClose={handleCloseChangeOrderModal}>
        <Box sx={{ ...modalStyle, maxHeight: "85%", width: "97%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1,
            }}
          >
            <Typography variant="h6" sx={{ mb: 1 }}>
              Change Order Register:
            </Typography>

            <Button
              onClick={handleAddRow}
              variant="contained"
              startIcon={<AddBoxIcon />}
            >
              Add
            </Button>
          </Box>
          {/* table */}

          <div style={{ marginTop: "5px" }}>
            <MaterialReactTable table={table} />
          </div>

          <Box sx={{ textAlign: "right", pt: 2 }}>
            <Button
              variant="outlined"
              color="error"
              sx={{ mx: 0.5 }}
              onClick={handleCloseChangeOrderModal}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
